import { Link, useParams } from "react-router-dom";
import { Seo } from "../components/Seo";
import { guideBySlug, guides } from "../content/guides";
import { NotFoundPage } from "./NotFoundPage";

export function GuideArticlePage() {
  const { slug } = useParams();
  const guide = slug ? guideBySlug.get(slug) : undefined;
  if (!guide) return <NotFoundPage />;

  return (
    <article className="article-page page-container">
      <Seo title={guide.seoTitle} description={guide.description} path={`/guias/${guide.slug}`} />
      <Link className="back-link" to="/guias">← Voltar para Guias</Link>
      <header className="article-header">
        <p className="eyebrow">GUIA · {guide.readTime}</p>
        <h1>{guide.title}</h1>
        <p>{guide.intro}</p>
      </header>
      {guide.sections.map((section) => (
        <section key={section.heading}>
          <h2>{section.heading}</h2>
          {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          {section.bullets && <ul className="check-list">{section.bullets.map((item) => <li key={item}>{item}</li>)}</ul>}
        </section>
      ))}
      <aside className="article-cta">
        <h2>Quer assistir tudo sem comprar título por título?</h2>
        <p>Conheça o Passe Vitalício e tire suas dúvidas com o suporte antes de comprar.</p>
        <Link className="primary-button" to="/vip">Conhecer o Passe Vitalício</Link>
      </aside>
      <section>
        <h2>Perguntas frequentes</h2>
        <div className="faq-list">{guide.faq.map((item) => <details key={item.question}><summary>{item.question}</summary><p>{item.answer}</p></details>)}</div>
      </section>
      <section>
        <h2>Continue lendo</h2>
        <div className="related-links">{guides.filter((item) => item.slug !== guide.slug).map((item) => <Link to={`/guias/${item.slug}`} key={item.slug}>{item.title} →</Link>)}</div>
      </section>
    </article>
  );
}
